import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Box, Typography } from "@mui/material";
import { OssPanel } from "../common/OssPanel";

const summaryCards = [
  ["전체", "total", "#3b82f6", ""],
  ["확인 필요", "checkRequired", "#f59e0b", "CHECK_REQUIRED"],
  ["변경 검토", "changeReview", "#8b5cf6", "CHANGE_REVIEW"],
  ["납기 위험", "deliveryRisk", "#ef4444", "DELIVERY_RISK"],
];

export const OssOrderSummaryCards = ({ summary, filters, onFilterChange }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" },
      gap: 1,
    }}
  >
    {summaryCards.map(([label, key, tone, value]) => {
      const active =
        (label === "전체" && !filters.status && !filters.riskLevel) ||
        filters.status === value ||
        filters.riskLevel === value;

      return (
        <OssPanel
          key={label}
          onClick={() => {
            if (label === "전체") {
              onFilterChange("status", "");
              onFilterChange("riskLevel", "");
              return;
            }
            if (label === "납기 위험") {
              onFilterChange("status", "");
              onFilterChange("riskLevel", active ? "" : "DELIVERY_RISK");
              return;
            }
            onFilterChange("riskLevel", "");
            onFilterChange("status", active ? "" : value);
          }}
          sx={{
            p: 1.45,
            minHeight: 82,
            display: "flex",
            alignItems: "center",
            gap: 1.1,
            cursor: "pointer",
            borderColor: active ? `${tone}88` : "#e0e4ec",
            boxShadow: active ? `inset 3px 0 0 ${tone}` : "0 4px 12px rgba(15, 23, 42, 0.04)",
          }}
        >
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              display: "grid",
              placeItems: "center",
              bgcolor: `${tone}14`,
              color: tone,
            }}
          >
            <FilterAltOutlinedIcon fontSize="small" />
          </Box>
          <Box>
            <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: "#4b5563" }}>{label}</Typography>
            <Typography sx={{ mt: 0.25, fontSize: 24, lineHeight: 1, fontWeight: 800, color: "#111827" }}>
              {summary[key]}
              <Box component="span" sx={{ ml: 0.25, fontSize: 12, fontWeight: 600, color: "#4b5563" }}>건</Box>
            </Typography>
          </Box>
        </OssPanel>
      );
    })}
  </Box>
);
